import { FETCH_DATA_FAILURE, FETCH_DATA_REQUEST, FETCH_DATA_SUCCESS } from "./actionTypes";

// List of API endpoints
const apiEndpoints = [
  'countryDetails',
  'loggedInDetails',
  'generateDossierDetails',
  'productDetails',
  'regiObjectiveDetails',
  'binderSelectionDetails',
  'lookDetails',
  'verifyTokenDetails',
];

// Dynamically generate the initial state
const initialState = apiEndpoints.reduce((state, endpoint) => {
  state[endpoint] = {
    data: [],
    loading: false,
    error: null,
  };
  return state;
}, {});

const apiReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return {
        ...state,
        [action.api]: {
          ...state[action.api],
          loading: true,
          error: null,
        },
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        [action.api]: {
          data: action.payload || [],
          loading: false,
          error: null,
        },
      };
    case FETCH_DATA_FAILURE:
      return {
        ...state,
        [action.api]: {
          ...state[action.api],
          loading: false,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

export default apiReducer;